import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'suffix'
})
export class SuffixPipe implements PipeTransform {

  transform(input: string, suffix: string): string {
    return (input && input.trim().length > 0) ? `${input}${suffix}` : null;
  }
}
